import { createFileRoute } from '@tanstack/react-router'

import { forbiddenErrorComponent, requirePermission } from '@/lib/routeGuards'
import { StudioLayout } from '@/pages/Studio/StudioLayout'

export const Route = createFileRoute('/_app/studio')({
  component: StudioLayout,
  beforeLoad: ({ context }) => {
    requirePermission(context.permissions, 'read:devices:config')
  },
  errorComponent: forbiddenErrorComponent,
})
